import utils from './utils';

export class FileWrapper {
  // eslint-disable-next-line no-useless-constructor
  constructor(public file: File) {}

  getMbSize() {
    return this.file.size / (1024 * 1024);
  }

  getBase64() {
    return utils.getBase64(this.file);
  }

  getByteArray() {
    return utils.getBase64(this.file);
  }
}
